<template>
  <modal v-if="modalExitAllOrder" v-model:show="showModal" :showClose="false" :clickClose="false">
    <template v-slot:header>
      <h5 class="modal-title">You are about to exit all positions for all the users</h5>
    </template>
    <form id="my-form">
      <div>
        <label for="recipient-name" class="text-black text-xs font-weight-bold text-capitalize">
          strategies:</label>
        <base-input name="selectmultiple" class="w-100 mr-2">
          <el-select v-model="tempPortfolios" multiple filterable :collapse-tags="shouldCollapseTagsStrategies"
            placeholder="Select Strategies" @change="handleSelectAllStrategies">
            <el-option :key="'select_all_strategies'" :label="selectAllStrategiesLabel" value="select_all_strategies">
            </el-option>
            <el-option v-for="option in sortedSelectOptions" :key="option.key" :label="option.value"
              :value="option.key">
            </el-option>
          </el-select>
        </base-input>
      </div>
    </form>
    <div class="mt-4 d-flex justify-content-end">
      <button type="button" class="btn btn-secondary" @click="closeModal()">Close</button>
      <button class="btn btn-primary" type="button" @click="validateExitAllOrder()">Exit All Orders</button>
    </div>
    <div v-if="errorFlag" class="mt-3 d-flex justify-content-center">
      <small class="text-danger">{{ errorMessage }}</small>
    </div>
  </modal>
  <modal v-model:show="showVerifyModal" :showClose="false" :clickClose="false">
    <form>
      <div class="mb-3">
        <h1 class="display-1 mb-0 text-center text-primary">{{ randomNum }}</h1>
      </div>
      <div class="mb-3">
        <label for="user-input"
          class="text-black text-sm d-flex justify-content-center align-item-center font-weight-bold text-capitalize">
          please enter the provided number:
        </label>
        <input type="text" v-model="userInput" class="form-control d-flex justify-content-center align-item-center"
          id="user-input" maxlength="3" placeholder="Enter 3-digit number" />
      </div>
    </form>
    <div class="mt-4 d-flex justify-content-end">
      <button type="button" class="btn btn-secondary" @click="goToPrevious()">Edit</button>
      <button class="btn btn-primary" type="button" @click="validateInput();">Verify</button>
    </div>
    <div class="mt-3 d-flex justify-content-center">
      <small class="text-danger">{{ validationMessage }}</small>
    </div>
    <div v-if="errorFlag" class="mt-3 d-flex justify-content-center">
      <small class="text-danger">{{ errorMessage }}</small>
    </div>
  </modal>
</template>
<script>
import {
  ElSelect,
  ElOption,
  ElInput,
} from "element-plus";
import Modal from "@/components/Modal";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
export default {
  components: {
    Modal,
    [ElSelect.name]: ElSelect,
    [ElOption.name]: ElOption,
    [ElInput.name]: ElInput,
  },
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    modalExitAllOrder: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      errorFlag: false,
      errorMessage: "",
      selectOptions: [],
      tempPortfolios: [],
      showVerifyModal: false,
      randomNum: '',
      userInput: "",
      validationMessage: "",
    }
  },
  computed: {
    selectAllStrategiesLabel() {
      return this.tempPortfolios.length === this.selectOptions.length
        ? 'Deselect All Strategies'
        : 'Select All Strategies';
    },
    shouldCollapseTagsStrategies() {
      const totalStrategies = this.selectOptions.length;
      return (this.tempPortfolios.length === totalStrategies && totalStrategies > 10)
        || this.tempPortfolios.length > 8;
    },
    sortedSelectOptions() {
      return [...this.selectOptions].sort((a, b) => {
        const isASelected = this.tempPortfolios.includes(a.key);
        const isBSelected = this.tempPortfolios.includes(b.key);
        if (isASelected === isBSelected) {
          return a.value.localeCompare(b.value);
        }
        return isASelected ? -1 : 1;
      });
    }
  },
  methods: {
    handleSelectAllStrategies(value) {
      const allStrategyKeys = this.selectOptions.map(option => option.key);
      const hasSelectAll = value.includes('select_all_strategies');
      if (hasSelectAll) {
        if (this.tempPortfolios.length === allStrategyKeys.length + 1) {
          this.tempPortfolios = [];
        } else {
          this.tempPortfolios = [...allStrategyKeys];
        }
      } else {
        if (this.tempPortfolios.includes('select_all_strategies')) {
          this.tempPortfolios = this.tempPortfolios.filter(v => v !== 'select_all_strategies');
        }
      }
    },
    closeModal() {
      this.errorFlag = false;
      this.tempPortfolios = [];
      this.validationMessage = "";
      this.userInput = "";
      this.$emit('updateParameters', false, false);
    },
    validateExitAllOrder() {
      this.getRandomNumber()
      this.$emit("updateParameters", false, this.modalExitAllOrder);
      this.showVerifyModal = true;
    },
    goToPrevious() {
      this.showVerifyModal = false;
      this.$emit("updateParameters", true, this.modalExitAllOrder);
    },
    validateInput() {
      if (parseInt(this.userInput) === this.randomNum) {
        this.validationMessage = "";
        this.exitAllOpenOrders();
      } else {
        this.errorFlag = false;
        this.validationMessage = "Incorrect number. Please try again.";
      }
    },
    getRandomNumber() {
      this.randomNum = Math.floor(100 + Math.random() * 900);
    },
    async exitAllOpenOrders() {
      var self = this;
      const ignoringPortfolios = self.selectOptions
        .filter(option => !self.tempPortfolios.includes(option.key))
        .map(option => option.key);
      let data = {
        "otp": "123",
        "ignoringPortfolios": ignoringPortfolios,
      }
      self.$store
        .dispatch("settingStore/exitAllOrders", data, { root: true })
        .then(function (response) {
          self.showVerifyModal = false;
          self.$emit('updateParameters', false, false);
          swal.fire({
            title: "Exit all Orders!",
            text: "Request to exit all orders are placed.",
            buttonsStyling: false,
            customClass: {
              confirmButton: "btn btn-success",
            },
            icon: "success",
          });
        }).catch(function (error) {
          self.errorFlag = true;
          self.errorMessage = error.server.response.data.message;
        });
    },
    getPortfolioNames() {
      let data = {
        type: 'portfolio-name'
      };
      if (sessionStorage.getItem(data.type + "-reference-data")) {
        this.selectOptions = JSON.parse(sessionStorage.getItem(data.type + "-reference-data"))
      } else {
        this.$store.dispatch("commonStore/getReferenceData", data, { root: true })
          .then(response => {
            this.selectOptions = response.server.data;
            sessionStorage.setItem(data.type + "-reference-data", JSON.stringify(this.selectOptions));
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
  },
  mounted() {
    this.getPortfolioNames();
  }
};
</script>
